



















import { Vue, Component } from 'vue-property-decorator';

import LoadingIcon from '@/components/common/LoadingIcon.vue';
import TournamentsShort from './partials/TournamentsShort.vue';
import { RecentTournamentsInterface } from '@/interfaces/interfaces';
import { fetchTournamentsList, getRecentTournaments } from '@/services/TournamentService';

@Component({
  components: { LoadingIcon, TournamentsShort }
})
export default class Home extends Vue {
  private error: boolean = false;
  private loading: boolean = true;
  private recentTournaments: RecentTournamentsInterface = {
    current: [],
    upcoming: [],
    past: []
  };

  public created() {
    this.fetchData();
  }

  private async fetchData() {
    const tournaments = await fetchTournamentsList();
    this.recentTournaments = getRecentTournaments(tournaments);

    if (!this.recentTournaments) {
      this.error = true;
    }

    this.loading = false;
  }
}
